import React from "react";
import { HiOutlineMapPin } from "react-icons/hi2";
import { useDispatch, useSelector } from "react-redux";
import { setCityDialog } from "../../../../app/slices/provincesSlice";
import CityHeader from "./home/header";
import CityTable from "./home/table";
import FormDialog from "../../../../components/FormDialog";

const City = () => {
  const dispatch = useDispatch();

  const _City = useSelector((state) => state.provinces);

  const handlDialog = () => {
    dispatch(setCityDialog());
  };

  return (
    <FormDialog
      open={_City.openCityDialog}
      onClose={() => {
        handlDialog();
      }}
      icon={<HiOutlineMapPin />}
      title="مدن محافظة"
      subtitle={_City.selectedProvince?.name}
      maxWidth='md'
    >
      <CityHeader />
      <CityTable />
    </FormDialog>
  );
};

export default City;
